module.exports = __webpack_public_path__ + "static/media/aljibesAlcaldesa.fca6af8b.mp3";